(function () {
  'use strict';

  angular
    .module('component.modify-cart-item', [])

    .component('buttonModifyCartItem', {
      require: {
        productCtrl: '?^^productDetail'
      },
      bindings: {
        size: '@?',
        btnClass: '@',
        isPrimary: '<',
        addToCartActive: '<',
        allowAddToCart: '<',
        titleAdd: '@?',
        titleAlert: '@?',
        titleModifyOk: '@?',
        tooltip: '@',
        modalCtrl: '<',
        device: '<'
      },
      templateUrl: 'component.modify-cart-item.tpl',
      /* @ngInject */
      controller: ["LoadService", function (LoadService) {
        var ctrl = this;

        ctrl.$onInit = function () {
          ctrl.js = $(document.body).data('js-components');
          LoadService.getService('AsyncComponentsService', { ctrl: ctrl }, 'initModify');
        };
      }]
    });

})();
